<template>
  <div class="el-col-24">
    <h5 class="warp-title">工单问题分类管理</h5>
    <div class="fast-warp" style="margin-bottom: 30px">
      <el-button v-if="querybtn.customerworkorder_classify_add === 1" class="md_20" size="mini" type="primary" @click="firstAdd">添加一级</el-button>
      <el-tree :data="dataList" :expand-on-click-node="false">
        <div class="custom-tree-node" slot-scope="{ node, data }">
          <el-input size="mini" class="w200" v-model="data.label" placeholder="" maxlength="50"></el-input>
          <span class="text-style">
            <el-button v-if="data.flag===1" type="text" size="mini" @click="() => append(node, data)">新增</el-button>
            <el-button type="text" size="mini" @click.stop="() => toChange(node, data)" v-if="querybtn.customerworkorder_classify_transfer === 1 && data.flag===2 && data.id">转移工单</el-button>
            <el-button type="text" size="mini" @click.stop="() => remove(node, data)" v-if="querybtn.customerworkorder_classify_del === 1">删除</el-button>
          </span>
        </div>
      </el-tree>
      <el-button class="mt_20" @click="initData()" v-if="querybtn.customerworkorder_classify_edit === 1">不保存</el-button>
      <el-button class="mt_20" type="primary" @click="submitForm()" :loading="isSubmitLoading" v-if="querybtn.customerworkorder_classify_edit === 1">保存</el-button>
    </div>
    <el-dialog
      title="工单转移"
      :visible.sync="dialogVisible"
      width="30%">
      <el-form :inline="true" ref="changeForm" :model="changeForm" class="demo-form-inline" size="small" :rules="changeFormRules">
        <el-form-item label="一级分类" prop="transferOneId">
          <el-select v-model="changeForm.transferOneId" placeholder="请选择" @change="OneTypeChange">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in oneTypeOption" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级分类" prop="transferTwoId">
          <el-select v-model="changeForm.transferTwoId" placeholder="活动区域">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in twoTypeOption" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="submitChange" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {queryManyTypeList, queryBusinessTypeList, saveSysDictionaryType, delSysDictionaryType, transferSysDictionaryType, querySysDictionaryListByType} from '../../api/order/index'
// import {sysDictionary} from '../../api/fast/index'
import { queryButtonPermission } from '../../api/public/auth'
import $ from 'jquery'
export default {
  name: 'OrderProblem',
  created () {
    // 打印是否登录
    console.log(this.$store.state.Auth.sign)
    let data = {
      id: global.$sider
    }
    queryButtonPermission(data).then((info) => {
      if (info.data.resultCode === 0) {
        this.querybtn = info.data.resultData
      } else {
        this.$message.error(info.data.resultMessage)
      }
    })
  },
  mounted () {
    // this.getProblemList()
    this.initData()
    if (document.documentElement) {
      document.documentElement.scrollTop = '3000px'
    } else if (document.body) {
      document.body.scrollTop = '3000px'
    }
  },
  data () {
    return {
      twoId: '',
      changeFormRules: {
        transferOneId: [
          {required: true, message: '请选择一级问题分类', trigger: 'blur'}
        ],
        transferTwoId: [
          {required: true, message: '请选择二级问题分类', trigger: 'blur'}
        ]
      },
      oneTypeOption: [],
      twoTypeOption: [],
      changeForm: {
        transferOneId: '',
        transferTwoId: ''
      },
      isSubmitLoading: false,
      querybtn: {},
      dataList: [],
      dialogVisible: false
    }
  },
  watch: {
    dialogVisible () {
      if (!this.dialogVisible) {
        this.oneTypeOption = ''
        this.$refs.changeForm.resetFields()
      } else {
        this.getProblemList()
      }
    }
  },
  methods: {
    OneTypeChange () {
      if (this.changeForm.transferOneId !== '') {
        let selectedInfo = ''
        selectedInfo = this.oneTypeOption.find((item) => {
          return item.id === this.changeForm.transferOneId
        })
        let data = {
          typeCode: 'im_customer_problem_two_type',
          pid: selectedInfo.id
        }
        queryBusinessTypeList(data).then(info => {
          if (info.data.resultCode === 0) {
            this.changeForm.transferTwoId = ''
            this.twoTypeOption = info.data.resultData
          } else {
            this.$message.error(info.data.resultMessage)
          }
        })
      } else {
        this.changeForm.transferTwoId = ''
        this.twoTypeOption = []
      }
    },
    getProblemList () {
      queryManyTypeList().then(res => {
        if (res.data.resultCode === 0) {
          this.oneTypeOption = res.data.resultData.imCustomerProblemOneType
          this.$forceUpdate()
        } else {
          this.$message.error(res.data.resultMessage)
        }
      })
    },
    submitChange () {
      this.$refs.changeForm.validate(res => {
        if (res) {
          let data = {
            twoId: this.twoId,
            transferTwoId: this.changeForm.transferTwoId
          }
          transferSysDictionaryType(data).then(res => {
            if (res.data.resultCode === 0) {
              this.$message.success('转移成功')
              this.dialogVisible = false
              this.initData()
            } else {
              this.$message.error(res.data.resultMessage)
            }
          })
        }
      })
    },
    toChange (node, data) {
      this.twoId = data.id
      this.dialogVisible = true
    },
    initData () {
      let data = {
        typeCode: 'im_customer_problem_one_type'
      }
      querySysDictionaryListByType(data).then(info => {
        if (info.data.resultCode === 0) {
          this.dataList = info.data.resultData
        } else {
          this.$message.error(info.data.resultMessage)
        }
      })
    },
    firstAdd () {
      this.dataList.push({
        id: '',
        label: '',
        flag: 1
      })
      setTimeout(() => {
        let element = $('.el-tree .el-tree-node').last()[0]
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
      }, 10)
    },
    // 滚动到添加的数据
    scrollToAddOne () {
      setTimeout(() => {
        let element = $('.is-current .el-tree-node__children .custom-tree-node').last()[0]
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
      }, 10)
    },
    append (node, data) {
      node.expanded = true
      const newChild = { id: '', label: '', flag: 2, children: [] }
      if (!data.children) {
        this.$set(data, 'children', [])
      }
      data.children.push(newChild)
      this.scrollToAddOne()
    },
    remove (node, data) {
      this.$confirm('是否删除这一分类', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        if (data.id) {
          let datas = {
            id: data.id
          }
          delSysDictionaryType(datas).then(info => {
            if (info.data.resultCode === 0) {
              this.$message.success('删除成功')
              const parent = node.parent
              const children = parent.data.children || parent.data
              const index = children.findIndex(d => d.id === data.id)
              children.splice(index, 1)
            } else {
              this.$message.error(info.data.resultMessage)
            }
          })
        } else {
          const parent = node.parent
          const children = parent.data.children || parent.data
          const index = children.findIndex(d => d.id === data.id)
          children.splice(index, 1)
        }
      })
    },
    submitForm () {
      let data = {
        jsonObject: JSON.stringify(this.dataList)
      }
      this.isSubmitLoading = true
      saveSysDictionaryType(data).then(info => {
        this.$message.success('保存成功')
        this.getProblemList()
        this.isSubmitLoading = false
        if (info.data.resultCode === 0) {
          this.initData()
        } else {
          this.$message.error(info.data.resultMessage)
        }
      }).catch(() => {
        this.isSubmitLoading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  /deep/.el-input__inner {
    height: 32px;
    font-size: 16px;
  }
}
/deep/.el-tree-node__content{
  height: 36px;
}
/deep/.el-tree-node__expand-icon{
  font-size: 20px;
}
.text-style .el-button{
  font-size: 16px;
}
.w200{
  width: 200px;
}
.md_20 {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/OrderProblem.vue